import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { FormProvider, useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import * as yup from "yup";
import BasicInformation from "./BasicInformation";
import { SignUpAPI, WeighmentIndicatorsAPI } from "api";
import { customSettings } from "utils/customConfig";
import { toast } from "react-toastify";
import PageTitle from "utils/PageTitle";
import BreadCrumbTable from "components/breadcrumb/BreadCrumbTable";

const schema = yup
  .object({
    number: yup.string(),
    date: yup.string(),
    customer: yup.string(),
    totalAmount: yup.string(),
    status: yup.string(),
    details: yup.array().of(
      yup.object({
        product: yup.string(),
        variant: yup.string(),
        quantity: yup.string(),
        price: yup.string(),
        coupon: yup.string(),
        discount: yup.string(),
        shippingCharges: yup.string(),
      })
    ),
  })
  .required();

const AddOrder = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  const submittedValues = {};
  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: { details: [{}] },
  });
  const { handleSubmit, reset, setValue } = methods;

  const onSubmit = async (data) => {
    let myData = {
      ...data,
      id: location?.state?.id ?? 0, // Use nullish coalescing to handle undefined or null
    };

    // console.log(myData);

    // try {
    //   if (location?.state) {
    //     setLoading(true);
    //     await WeighmentIndicatorsAPI.post(myData);
    //     setLoading(false);
    //     toast.success("Weighment Indicator Updated Successfully", {
    //       position: customSettings.toastPosition,
    //       autoClose: customSettings.toastClose,
    //     });
    //   } else {
    //     setLoading(true);
    //     await WeighmentIndicatorsAPI.post(myData);
    //     setLoading(false);
    //     toast.success("Weighment Indicator Created Successfully", {
    //       position: customSettings.toastPosition,
    //       autoClose: customSettings.toastClose,
    //     });
    //   }

    //   // ------- Get all object keys form data and set empty values to reset ------------
    //   const keys = Object.keys(data);
    //   for (const key of keys) {
    //     submittedValues[key] = "";
    //   }
    //   reset({ ...submittedValues });
    //   navigate(-1);
    // } catch (error) {
    //   toast.error("Something Went Wrong", {
    //     position: customSettings.toastPosition,
    //     autoClose: customSettings.toastClose,
    //   });
    //   console.log(error);
    // }
  };

  useEffect(() => {
    if (location?.state) {
      reset(location.state);
    }
  }, [setValue]);

  return (
    <>
      <PageTitle name="E Commerce | Orders" />
      {/* <div className="py-2">
        <BreadCrumb />
      </div> */}
      <FormProvider {...methods}>
        <Form onSubmit={handleSubmit(onSubmit)} noValidate>
          <Card>
            <Card.Header className="border-bottom">
              <Row className="flex-between-center ">
                <Col md>
                  {/* <h5 className="fs-9 text-nowrap mb-2 mb-md-0">
                    {" "}
                    E Commerce | Orders
                  </h5> */}
                  <BreadCrumbTable title="E Commerce" subTitle="Orders" />
                </Col>
                <Col xs="auto">
                  <Button
                    variant="link"
                    className="text-secondary fw-medium p-0 me-3"
                    type="button"
                    onClick={() => navigate(-1)}
                  >
                    Cancel
                  </Button>
                  <Button variant="primary" type="submit" disabled={loading}>
                    Ok
                  </Button>
                </Col>
              </Row>
            </Card.Header>
            <BasicInformation />
          </Card>
        </Form>
      </FormProvider>
    </>
  );
};

export default AddOrder;
